module.exports = __webpack_public_path__ + "static/media/waring_icon.7051eb54.svg";